import type { FC } from 'react';
import { memo } from 'react';
import './index.scss';

interface SubscribeProductMobileProps {
  supplyDate?: string;
  openModal: () => void;
  breadCrumbsLastItem: string;
  changeUrlToUpBreadCrumbs: () => void;
}

const SubscribeProductMobile: FC<SubscribeProductMobileProps> = ({
  supplyDate,
  openModal,
  // breadCrumbsLastItem,
  changeUrlToUpBreadCrumbs
}) => (
  <div className='subscribe-to-product-modal'>
    <div className='mb-2.5 font-bold text-base'>
      Поставка ожидается {supplyDate}
    </div>
    <div className='grid gap-x-2.5 w-full grid-cols-[121px,auto]'>
      <button
        onClick={openModal}
        className='subscribe-to-product-modal__open-modal-btn'
      >
        Сообщить
      </button>
      <button
        type='button'
        onClick={changeUrlToUpBreadCrumbs}
        className='sm:w-full sm:text-sm sm:h-10 cursor-pointer h-[42px] rounded-lg bg-[var(--mid-yellow)] px-0 flex justify-center items-center transition-colors hover:bg-[var(--main-yellow)]'
      >
        Все товары раздела
      </button>
    </div>
  </div>
);

export default memo(SubscribeProductMobile);
